import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import Table from '../Table/Table'
import { Body } from '../Shell/Shell'
import BOSearch from '../BOSearch/BOSearch'
import { Spinner } from '../Loaders/Loaders'
import { GET_CSV_FROM_SEARCH, GET_LIENS_SEARCH_WEB_CART } from '../../requests'
import {
  clearSearchError,
  getSearchDescription,
  selectRow,
  setActiveCategory,
  setResults,
  setResultsMode,
  setSort,
  setSearchEdge,
  initializeSearchCacheAndStales,
} from './SearchActions'
import RecordDrawer from 'components/RecordDrawer/RecordDrawer'
import { calculateReceiptItemsTotal, getOrderedResultsByCategory } from 'utilities'
import { SUBROUTES_OBJ } from '../../App'
import SlidingPanel from 'components/SlidingPanel/SlidingPanel'
import Portal from 'components/Portal/Portal'
import ConnectedCheckout from 'components/Checkout/Checkout'
import './Search.scss'
import EmptySearchPlaceholder from './EmptySearchPlaceholder'
import SearchError from './SearchError'
import DownloadBox from '@tecuity/sos-icons/react/download-box'
import { IconButton } from '@tecuity/granite-ui/IconButton'
import { ConnectedSearchBox } from './SearchBox'
import { Helmet } from 'react-helmet'
import { setErrorToast } from '../../actions'

export class Search extends Component {
  constructor(props) {
    super()
    this.state = {
      ownershipModalOpen: false,
      requestOwnershipModal: false,
      pinsModalOpen: false,
      amendmentLauncherOpen: false,
      webcart: null,
      checkoutOpen: false,
      searchParameters: {},
      staffSearchTitle: '',
      edge:
        props.isServerPaginated ||
        (props.match.params.subParam &&
          SUBROUTES_OBJ[props.match.params.subParam].isServerPaginated)
          ? { PageSize: 10, PageNum: 1 }
          : {},
      loadingCSV: false,
    }
  }
  componentDidMount = () => {
    const category = this.props.match.params.subParam
    if (category) {
      if (!SUBROUTES_OBJ[category]) {
        const firstCategoryInList = Object.entries(SUBROUTES_OBJ).find((pairs) => {
          return pairs[1].DisplayInSearch
        })[0]
        this.props.setActiveCategory(firstCategoryInList)
      } else if (
        SUBROUTES_OBJ[category].ServerWebSearchDescription &&
        !this.props.serverDescription
      ) {
        this.props.getSearchDescription(this.props.match.params.subParam)
      }
      this.props.clearSearchError(this.props.match.params.subParam)
      if (
        (this.props.isServerPaginated || SUBROUTES_OBJ[category].isServerPaginated) &&
        !this.props.edge.PageSize
      ) {
        this.setEdgeDefaults()
      }
    }
    this.props.initializeSearchCacheAndStales()
  }
  componentDidUpdate = (prevProps) => {
    const categoryHasChanged = this.props.match.params.subParam !== prevProps.match.params.subParam
    if (!this.props.serverDescription) {
      this.props.getSearchDescription(this.props.match.params.subParam)
    }
    if (categoryHasChanged && this.props.match.params.subParam) {
      if (
        SUBROUTES_OBJ[this.props.match.params.subParam] &&
        SUBROUTES_OBJ[this.props.match.params.subParam].ServerWebSearchDescription &&
        !this.props.serverDescription
      ) {
        this.props.getSearchDescription(this.props.match.params.subParam)
      }
      const previousCategoryWasNotValid =
        !this.props.match.params.subParam && prevProps.match.params.subParam
      if (previousCategoryWasNotValid) {
        this.props.clearSearchError(this.props.match.params.subParam)
      }
      this.props.setActiveCategory(this.props.match.params.subParam)
      if (
        (this.props.isServerPaginated ||
          SUBROUTES_OBJ[this.props.match.params.subParam].isServerPaginated) &&
        !this.props.edge.PageSize
      ) {
        this.setEdgeDefaults()
      }
    }
  }
  selectRow = (row) => {
    this.props.selectRow(this.props.match.params.subParam, row.ID)
  }
  setResults = (results, searchValue) => {
    this.props.setResults(
      { edge: { ...this.state.edge }, ...results },
      this.props.match.params.subParam,
      searchValue
    )
    this.props.selectRow(this.props.match.params.subParam, null)
    if (
      this.props.isMobile &&
      this.props.orderedResults.rows &&
      this.props.orderedResults.rows.length > 0
    ) {
      window.scrollTo(0, this.searchResultsRef.offsetTop - 20)
    }
  }
  setSort = (sortId) => {
    //TODO: update this to make sure that when paginated, the page is set to 1.
    this.setState({ edge: { ...this.state.edge, PageNum: 1 } }, () => {
      this.props
        .setSort({
          category: this.props.match.params.subParam,
          sortBy: sortId,
          sortByDirection:
            this.props.sortBy === sortId
              ? this.props.sortByDirection === 'DESC'
                ? 'ASC'
                : 'DESC'
              : 'DESC',
        })
        .then(this.searchTrigger)
    })
  }
  onSidebarDismiss = () => {
    this.props.selectRow(this.props.match.params.subParam, null)
  }
  startLiensCheckout = (searchTerm, advancedParameters) => {
    GET_LIENS_SEARCH_WEB_CART(
      {
        searchTerm,
        advancedParameters,
        searchResults: this.props.orderedResults.rows.map((row) => row.ID),
      },
      ({ RECEIPT_ITEM_WEB_LIST, REF_NUM }) => {
        const total = calculateReceiptItemsTotal(RECEIPT_ITEM_WEB_LIST)
        this.setState(
          {
            webcart: {
              receiptItems: RECEIPT_ITEM_WEB_LIST,
              refNum: REF_NUM,
            },
            checkoutOpen: total > 0,
          },
          () => {
            if (total <= 0) {
              this.openReceipt()
            }
          }
        )
      },
      (err) => {
        console.error(err)
      }
    )
  }
  closeCheckout = () => {
    this.setState({ checkoutOpen: false })
  }
  cancelCheckout = () => {
    this.slider.closeSlider(() => {
      this.setState({ checkoutOpen: false, webcart: null })
    })
  }
  openReceipt = (refNum) => {
    if (this.slider) {
      this.slider.closeSlider(() => {
        this.props.history.push(`/receipt?ref=${refNum || this.state.webcart.refNum}`)
      })
    } else {
      this.props.history.push(`/receipt?ref=${refNum || this.state.webcart.refNum}`)
    }
  }
  onPrevClicked = () => {
    // console.log('next clicked', this.props.edge)
    const { PageNum, PageSize } = this.props.edge
    this.setState({ edge: { PageSize, PageNum: PageNum - 1 } }, () => {
      this.searchTrigger()
    })
  }
  onNextClicked = () => {
    // console.log('next clicked', this.props.edge)
    const { PageNum, PageSize } = this.props.edge
    this.setState({ edge: { PageSize, PageNum: PageNum + 1 } }, () => {
      this.searchTrigger()
    })
  }
  onPageSizeChange = (e) => {
    const { PageNum } = this.props.edge
    this.setState({ edge: { PageNum, PageSize: Number(e.target.value) } }, () => {
      this.searchTrigger()
    })
  }
  setEdgeDefaults = () => {
    this.props.setSearchEdge({
      category: this.props.match.params.subParam,
      PageNum: 1,
      PageSize: 10,
      TotalRows: 20,
    })
  }

  downloadCsv = () => {
    this.setState({ loadingCSV: true }, () => {
      GET_CSV_FROM_SEARCH(
        this.props.csvDownload,
        this.state.searchParameters,
        (content) => {
          let dataUri = `data:text/plain;charset=utf-8,${encodeURIComponent(content)}`
          let anchor = document.createElement('a')
          anchor.href = dataUri
          anchor.download = `Farm_Bill_Search_${new Date().toLocaleString('en-US', {
            month: 'numeric',
            day: 'numeric',
            year: 'numeric',
          })}.csv`
          document.body.appendChild(anchor)
          anchor.click()
          document.body.removeChild(anchor)
          this.setState({ loadingCSV: false })
        },
        (error) => {
          this.props.setErrorToast('Failed to download CSV')
          console.error(error)
          this.setState({ loadingCSV: false })
        }
      )
    })
  }

  searchTrigger = null

  searchResultsRef = null

  renderResults(props, sublink) {
    let headerClickedFunction = null
    if (props.onHeaderLabelClicked) {
      headerClickedFunction = (p) => {
        this.setState({ edge: { ...this.state.edge, PageNum: 1 } }, () => {
          props.onHeaderLabelClicked(p)
        })
      }
    } else if (process.env.SEARCH_IS_SORTABLE || sublink.searchIsSortable) {
      headerClickedFunction = this.setSort
    }

    let hidden = !(
      props.orderedResults.rows &&
      props.orderedResults.rows.length > 0 &&
      !props.isStale
    )

    return (
      <React.Fragment>
        <SearchError
          hidden={props.searching || !props.searchError}
          title={props.searchError ? props.searchError.title || '' : ''}
          message={props.searchError ? props.searchError.message || '' : ''}
        />
        <div>
          {this.props.csvDownload && (
            <h1
              style={{
                textAlign: 'right',
                maxWidth: '960px',
                margin: '0 auto',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '20px',
              }}
            >
              {this.state.loadingCSV && (
                <span style={{ paddingTop: '16px' }}>
                  <Spinner size="small" themeColor="dark-neutral" />
                </span>
              )}
                <span style={{ visibility: hidden ? 'hidden' : 'visible' }}>
                <IconButton
                  disabled={this.state.loadingCSV}
                  onClick={this.downloadCsv}
                  icon={<DownloadBox />}
                  label="Download CSV"
                  customCss={{
                    height: '35px',
                    width: '35px',
                    svg: { height: '30px', width: '30px', marginTop: '-7px' },
                  }}
                />
              </span>
            </h1>
          )}
          <Table

              hidden={hidden}
              aria-live="assertive"
            template={props.orderedResults.template}
            rows={props.orderedResults.rows}
            className="center-container"
            onCellClick={this.selectRow}
            selectedRowIndex={
              props.orderedResults.rows
                ? props.orderedResults.rows.findIndex((row) => row.ID === props.selectedId)
                : false
            }
            animated={false}
            sortable={props.sortable || sublink.searchIsSortable || process.env.SEARCH_IS_SORTABLE}
            sortBy={props.sortBy}
            sortByDirection={props.sortByDirection}
            onHeaderLabelClicked={headerClickedFunction}
            rowCount
            firstCellInteractive={props.firstCellInteractive}
            category={this.props.match.params.subParam}
            innerRef={(ref) => (this.searchResultsRef = ref)}
            totalRows={
              props.isServerPaginated || sublink.searchHasPagination
                ? props.edge
                  ? props.edge.TotalRows
                  : props.orderedResults.rows.length
                : null
            }
            isServerPaginated={props.isServerPaginated || sublink.IsPublicSearchServerPaginated} // TODO: make sure sublinks are matching in name.
            onPageSizeChange={this.onPageSizeChange}
            onNextClicked={this.onNextClicked}
            onPrevClicked={this.onPrevClicked}
          />
        </div>
        <EmptySearchPlaceholder
          hidden={!(props.orderedResults.rows && props.orderedResults.rows.length === 0)}
          searchTerm={props.currentSearchTerm}
        />
        <Spinner hidden={!(props.searching && !props.searchError)} className="search-loader" />
      </React.Fragment>
    )
  }

  updateStaffSearchTitle = (title) => {
    this.setState({ staffSearchTitle: title })
  }

  render() {
    const {
      orderedResults,
      results,
      selectedId,
      activeCategory,
      sublinks,
      sortBy,
      sortByDirection,
      sortable,
      getSearchTrigger,
      aboveSearchChildren,
      serverDescription,
      isStale,
    } = this.props
    const category = this.props.match.params.subParam
    const selectedResult = results[selectedId]
    if (selectedResult) {
      selectedResult.RECORD_NUM = selectedResult.RECORD_NUM
        ? selectedResult.RECORD_NUM
        : selectedResult.Num
    }
    const selectedTitle = selectedResult ? selectedResult.TITLE[0] : ''
    const selectedSubtitle = selectedResult ? selectedResult.TITLE[1] : ''
    const sublink = sublinks.find((l) => l.parameter === category) || {}
    const showSearchLiensCheckout = sublink.searchLiensCheckout === true
    const allowSearchPrint = sublink.allowSearchPrint === true
    // console.log(this.props.edge, this.state.edge, { ...this.props.edge, ...this.state.edge })

    if (!this.props.match.params.subParam) {
      let curLocation = this.props.location.pathname
      curLocation = curLocation.replace(/\/+$/, '')
      let url = `${curLocation}/${activeCategory ? activeCategory : sublinks[0].parameter}`
      return <Redirect to={url} />
    } else if (!sublink.parameter) {
      return <Redirect to={`/search/${sublinks[0].parameter}`} />
    } else {
      return (
        <Body className="search" showDrawer={selectedId}>
          <Helmet>
            <title>{`${
              this.props.match.params.subParam === 'back-office' && this.state.staffSearchTitle
                ? this.state.staffSearchTitle + ' | '
                : ''
            }  ${
              this.props.match.params.subParam.charAt(0).toUpperCase() +
                this.props.match.params.subParam.slice(1) || ''
            } Search | ${process.env.CUSTOM_TAB_TITLE || process.env.STATE_NAME} ${
              process.env.STATE_ORG_TITLE
            }`}</title>
          </Helmet>
          {aboveSearchChildren}
          {sublink.ServerWebSearchDescription && !serverDescription ? (
            <div className="flex-center-page">
              <Spinner className="animated fadeIn" themeColor="neutral" />
            </div>
          ) : (
            <React.Fragment>
              {sublink.parameter === 'back-office' ? (
                <BOSearch
                  match={this.props.match}
                  history={this.props.history}
                  sublinks={sublinks}
                  updateTitle={this.updateStaffSearchTitle}
                />
              ) : (
                <ConnectedSearchBox
                  match={this.props.match}
                  pushUpParameters={(parameters) => {
                    this.setState({ searchParameters: parameters })
                  }}
                  title={`${sublink.searchTitle || sublink.label || ''} Search`}
                  showSearchLiensCheckout={showSearchLiensCheckout}
                  allowSearchPrint={allowSearchPrint}
                  placeholder={
                    sublink.PublicSearchSettings.SearchPlaceholder ||
                    process.env.DEFAULT_SEARCH_PLACEHOLDER ||
                    `Search by name or ${process.env.SYSTEM_ID_LABEL.toLowerCase()} (###-#####)`
                  }
                  onResultsReceived={this.setResults}
                  category={category}
                  advancedParameters={sublink.PublicSearchSettings.Parameters}
                  searchRequirementsAreSatisfied={
                    sublink.PublicSearchSettings && sublink.PublicSearchSettings.SearchRequirements
                      ? typeof sublink.PublicSearchSettings.SearchRequirements === 'string'
                        ? // eslint-disable-next-line no-new-func
                          new Function(
                            'search',
                            'values',
                            sublink.PublicSearchSettings.SearchRequirements
                          )
                        : sublink.PublicSearchSettings.SearchRequirements
                      : sublink.searchRequirementsAreSatisfied
                  }
                  description={serverDescription || sublink.searchDescription}
                  hasResults={orderedResults.rows && orderedResults.rows.length > 0}
                  onPurchaseRequested={showSearchLiensCheckout ? this.startLiensCheckout : null}
                  sortable={sortable || sublink.searchIsSortable || process.env.SEARCH_IS_SORTABLE}
                  sortBy={sortBy}
                  sortByDirection={sortByDirection}
                  searchMustHaveOneOf={sublink.searchMustHaveOneOf}
                  minimumSearchCharacters={
                    sublink.PublicSearchSettings &&
                    sublink.PublicSearchSettings.MinimumSearchCharacters
                      ? sublink.PublicSearchSettings.MinimumSearchCharacters
                      : 2
                  }
                  advancedParametersStartOpen={sublink.advancedParametersStartOpen}
                  forceNumericalSearch={sublink.PublicSearchSettings.ForceNumericalSearch}
                  isStale={isStale}
                  getSearchTrigger={(trigger) => {
                    if (getSearchTrigger) getSearchTrigger(trigger)
                    this.searchTrigger = trigger
                  }}
                  history={this.props.history}
                  edge={{ ...this.props.edge, ...this.state.edge }}
                  isServerPaginated={
                    this.props.isServerPaginated || SUBROUTES_OBJ[category].isServerPaginated
                  }
                />
              )}
              {this.renderResults(this.props, sublink)}
            </React.Fragment>
          )}
          <RecordDrawer
            show={selectedId}
            title={selectedTitle}
            subtitle={selectedSubtitle}
            category={category}
            sourceId={selectedResult && selectedResult.ID}
            uccRecordId={selectedResult && selectedResult.UCC_RECORD_ID}
            recordNum={selectedResult && selectedResult.RECORD_NUM}
            canFileAR={selectedResult && selectedResult.CAN_FILE_AR}
            canAlwaysFileAR={selectedResult && selectedResult.CAN_ALWAYS_FILE_AR}
            canReinstate={selectedResult && selectedResult.CAN_REINSTATE}
            canFileReinstatement={selectedResult && selectedResult.CAN_FILE_REINSTATEMENT}
            sublink={sublink}
            selectedResult={selectedResult || {}}
            onSidebarDismiss={this.onSidebarDismiss}
          />
          <Portal isOpened={this.state.checkoutOpen}>
            <SlidingPanel
              closeOnShadeClick={false}
              closeSlider={this.closeCheckout}
              ref={(ref) => {
                this.slider = ref
              }}
            >
              <ConnectedCheckout
                cancelCheckout={this.cancelCheckout}
                closeModal={this.closeCheckout}
                redirectToReceipt={this.openReceipt}
                amendmentNum={this.state.checkoutOpen && this.state.webcart.amendmentNum}
                refNum={this.state.checkoutOpen && this.state.webcart.refNum}
                formDefinitionId={this.state.checkoutOpen && this.state.webcart.formDefinitionId}
                category={this.props.match.params.category}
                receiptItems={this.state.checkoutOpen && this.state.webcart.receiptItems}
              />
            </SlidingPanel>
          </Portal>
        </Body>
      )
    }
  }
}
export default connect(
  (state, props) => ({
    results:
      props.match.params.subParam && state.search.results
        ? state.search.results[props.match.params.subParam]
          ? state.search.results[props.match.params.subParam]
          : {}
        : {},
    orderedResults:
      props.match.params.subParam &&
      state.search.results &&
      state.search.results[props.match.params.subParam]
        ? getOrderedResultsByCategory(
            props.match.params.subParam,
            state.search.results,
            state.search.templates
          )
        : [],
    edge:
      (props.match.params.subParam && state.search.results
        ? state.search.edges[props.match.params.subParam]
        : {}) || {},
    serverDescription:
      (props.match.params.subParam && state.search.descriptions[props.match.params.subParam]) || '',
    searching: state.search.searching,
    selectedId: props.match.params.subParam
      ? state.search.selected[props.match.params.subParam]
      : null,
    resultsMode: state.search.resultsMode,
    isMobile: state.app.isMobile,
    activeCategory: state.search.activeCategory || state.app.currentCategory,
    sortBy: props.sortBy
      ? props.sortBy
      : (state.search.sorts[props.match.params.subParam] || {}).sortBy,
    sortByDirection: props.sortByDirection
      ? props.sortByDirection
      : (state.search.sorts[props.match.params.subParam] || {}).sortByDirection,
    currentSearchTerm:
      props.match.params.subParam &&
      state.search.searchValueCache &&
      state.search.searchValueCache[props.match.params.subParam]
        ? state.search.searchValueCache[props.match.params.subParam]
        : '',
    searchError: state.search.searchError[props.match.params.subParam],
    isStale: state.search.stales[props.match.params.subParam] || false,
  }),
  {
    setResults,
    selectRow,
    setResultsMode,
    setActiveCategory,
    setSort,
    setSearchEdge,
    getSearchDescription,
    clearSearchError,
    setErrorToast,
    initializeSearchCacheAndStales,
  }
)(Search)
